<template>
  <v-container class="content-wrapper" fluid>
    <v-row class="mb-10 justify-start">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="6"
        sm="6"
        xs="12"
        class="pa-3"
        v-for="(equipment, index) in equipments"
        :key="'equipment-' + index"
      >
        <v-hover v-slot="{ hover }">
          <v-card
            class="d-flex flex-column"
            elevation="3"
            style="border-radius: 24px; height: 100%; "
            :class="{ 'on-hover': hover }"
            @click="handleCardClick(equipment.id, $event)"
          >
            <div style="position: relative; width: 100%; text-align: center; overflow: hidden;">
              <v-app-bar
                flat
                class="custom-app-bar"
                style="position: absolute; top: 0; left: 0; width: 100%; z-index: 1; background: transparent;"
              >
                <v-chip flat label small color="blue" class="white--text font-weight-bold">
                  Equipment
                </v-chip>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!equipment.isFavorite && $store.getters.roles"
                  @click="addFavorite(equipment)"
                  icon
                  raised
                  medium
                >
                  <v-icon>mdi-heart-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="equipment.isFavorite && $store.getters.roles"
                  @click="removeFavorite(equipment)"
                  icon
                  raised
                  medium
                  color="red"
                >
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
              </v-app-bar>
              <div style="display: flex; justify-content: center; width: 100%; overflow: hidden;">
                <v-img
                  v-if="equipment.picture"
                  height="200px"
                  max-width="100%"
                  v-bind:src="equipment.picture"
                  :style="{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }"
                ></v-img>
                <v-img
                  v-else-if="equipment.logo"
                  height="200px"
                  max-width="80%"
                  contain
                  v-bind:src="equipment.logo"
                  :style="{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }"
                ></v-img>
                <v-img
                  v-else
                  height="200px"
                  max-width="100%"
                  lazy-src="@/assets/img/blur.jpg"
                  :style="{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }"
                ></v-img>
              </div>
            </div>

            <v-card-text>
              <div class="text-start" align="start" justify="start">
                <v-col cols="12" class="black--text">
                  <b style="font-size: 20px;">{{ equipment.name }}</b>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Provider</label>
                  <div v-if="$store.getters.roles">
                    <router-link
                      :to="{
                        name: 'OverviewProvider',
                        params: { id: equipment.provider.id },
                        query: {
                          marketplaceEquipmentViewAll: true,
                          fromTable: true,
                          ...getParams(),
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ equipment.provider.name }}
                    </router-link>
                  </div>
                  <div v-else>
                    <router-link
                      :to="{
                        name: 'PublicOverviewProvider',
                        params: { id: equipment.provider.id },
                        query: {
                          marketplaceEquipmentViewAll: true,
                          fromTable: true,
                          ...getParams(),
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ equipment.provider.name }}
                    </router-link>
                  </div>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Hosting Institution</label>
                  <div v-if="$store.getters.roles">
                    <router-link
                      :to="{
                        name: 'OverviewHostingInstitution',
                        params: { id: equipment.hostingInstitution.id },
                        query: {
                          marketplaceEquipmentViewAll: true,
                          fromTable: true,
                          ...getParams(),
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ equipment.hostingInstitution.name }}
                    </router-link>
                  </div>
                  <div v-else>
                    <router-link
                      :to="{
                        name: 'PublicOverviewHostingInstitution',
                        params: { id: equipment.hostingInstitution.id },
                        query: {
                          marketplaceEquipmentViewAll: true,
                          fromTable: true,
                          ...getParams(),
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ equipment.hostingInstitution.name }}
                    </router-link>
                  </div>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Scientific Domain</label>
                  <div v-for="(domain, index) in equipment.domains.slice(0, 1)" :key="index">
                    <v-chip small>
                      {{ domain }}
                    </v-chip>
                    <v-chip
                      class="mx-1"
                      small
                      v-if="equipment.domains.length > 1"
                      color="primary200"
                    >
                      +{{ equipment.domains.length - 1 }}
                    </v-chip>
                  </div>
                </v-col>
              </div>
            </v-card-text>

            <v-spacer></v-spacer>
            <v-divider class="custom-divider"></v-divider>

            <v-card-actions>
              <v-row align="center">
                <v-col class="d-flex align-center">
                  <v-btn @click="redirectToOverview(equipment.id)" icon style="min-width: auto;">
                    <v-icon style="color: rgba(0, 0, 0, 0.87)!important;" class="mr-2">
                      mdi-arrow-top-right
                    </v-icon>
                  </v-btn>
                  <p class="mb-0">More Details</p>
                </v-col>
                <v-col class="d-flex justify-end" v-if="equipment.email != null">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="!$store.getters.roles"
                        @click.stop="openLoginModal(equipment.id)"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon style="color: rgba(0, 0, 0, 0.87)!important;">
                          mdi-email-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Contact</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-row v-if="pagesLength > 1">
      <v-spacer></v-spacer>
      <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
        <div>{{ totalItems }} Results</div>
      </v-col>
      <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
        <div class="pr-2">Show:</div>
        <div style="max-width: 90px">
          <v-select
            v-model="options.itemsPerPage"
            :items="[10, 20, 30, 40, 50, 100]"
            dense
            outlined
            hide-details
            @change="onItemsPerPageChange"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="justify-end d-flex flex-row align-center">
        <v-pagination
          v-model="options.page"
          :length="pagesLength"
          :total-visible="7"
          @input="onPageChange"
        ></v-pagination>
      </v-col>
    </v-row>

    <!-- Non registered dialog -->
    <v-dialog v-model="modalLogIn" max-width="1000px" :retain-focus="false" hide-overlay>
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="px-0 py-0">
          <v-row class="mx-0 px-2" align="center">
            <v-col cols="11" class="text-center d-flex justify-center align-center">
              This action requires authentication
            </v-col>
            <v-col cols="1" class="pl-0">
              <v-btn fab small text @click="modalLogIn = false">
                <v-icon color="neutral500">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
        <v-card-text class="pa-0 text-center">
          Only authenticated users are allowed to perform this action. Please
          <router-link :to="{ name: 'OverviewEquipment', params: { id: selectedEquipmentId } }"
            ><span class="font-weight-bold">Log In</span></router-link
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'MarketplaceEquipmentViewAll',
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      equipments: [],
      totalItems: 0,
      pagesLength: null,
      loading: false,
      equipment: {
        name: '',
        logo: '',
        picture: '',
        provider: {
          name: '',
          id: null,
        },
        isFavorite: false,
      },
      currentSortParams: '',
      modalLogIn: false,
      selectedEquipmentId: '',
    };
  },
  props: {
    sortParams: {
      type: String,
    },
  },
  mounted() {
    if (this.$route.query.index !== undefined) {
      const index = parseInt(this.$route.query.index);
      this.options.page = index + 1;
    }
    if (this.$route.query.size !== undefined) {
      this.options.itemsPerPage = parseInt(this.$route.query.size);
    }
    this.currentSortParams = this.sortParams || '';
    this.getDataFromApi(this.currentSortParams);
  },
  watch: {
    sortParams: {
      deep: true,
      immediate: false,
      handler(newVal) {
        console.log('sortParams changed:', newVal);
        this.currentSortParams = newVal;
        this.getDataFromApi(newVal);
      },
    },
  },
  methods: {
    getDataFromApi(sortParams = this.currentSortParams) {
      console.log('[Table] Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);

      const baseUrl = '/api/v1/equipment';
      const params = this.getParams();

      const url = `${baseUrl}?index=${params.index}&size=${params.size}${
        sortParams ? `&${sortParams}` : ''
      }`;

      this.axios
        .get(url)
        .then(res => {
          if (res.status === 200) {
            console.log('Get Equipment', res.data);
            this.equipments = res.data.content;
            this.totalItems = res.data.total;
            this.pagesLength = res.data.pagesLength;
          }
        })
        .finally(() => {
          this.loading = false;
          EventBus.$emit('waiting', false);
        });
    },
    onItemsPerPageChange() {
      this.options.page = 1;
      this.getDataFromApi(this.currentSortParams);
    },
    onPageChange(newPage) {
      this.options.page = newPage;
      this.getDataFromApi(this.currentSortParams);
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      return {
        index: itemsPerPage === -1 ? 0 : page - 1,
        size: itemsPerPage === -1 ? 1000 : itemsPerPage,
      };
    },
    handleCardClick(equipmentId, event) {
      if (event.target.closest('a, button, .v-btn, .v-icon')) {
        return;
      }
      this.redirectToOverview(equipmentId);
    },
    redirectToOverview(equipmentId) {
      if (this.$store.getters.roles != null) {
        const marketplaceEquipmentViewAll = true;

        this.$router.push({
          name: 'OverviewEquipment',
          params: { id: equipmentId },
          query: {
            marketplaceEquipmentViewAll,
            fromTable: true,
            ...this.getParams(),
          },
        });
      } else {
        const marketplaceEquipmentViewAll = true;

        this.$router.push({
          name: 'PublicOverviewEquipment',
          params: { id: equipmentId },
          query: {
            marketplaceEquipmentViewAll,
            fromTable: true,
            ...this.getParams(),
          },
        });
      }
    },
    addFavorite(equipment) {
      const id = equipment.id;
      EventBus.$emit('waiting', true);

      this.axios
        .post(`/api/v1/favorites-equipments/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite added successfully',
          });
          this.getDataFromApi();
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removeFavorite(equipment) {
      const id = equipment.id;
      EventBus.$emit('waiting', true);

      this.axios
        .delete(`/api/v1/favorites-equipments/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite removed successfully',
          });
          this.getDataFromApi();
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    openLoginModal(equipmentId) {
      this.modalLogIn = true;
      this.selectedEquipmentId = equipmentId;
    },
  },
};
</script>

<style scoped>
.custom-divider {
  padding: 5px 0;
  margin: 0 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}

.custom-app-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: none !important;
}
</style>
